import { VersionStringBuilder } from "../version/version-string-builder";
import { DependencyInjectionContainer } from "./dependency-injection-container";

const versionStringBuilder = "versionStringBuilder";

export const getVersionStringBuilder = () => {
  return DependencyInjectionContainer.getInstance().resolve<VersionStringBuilder>(
    versionStringBuilder,
  );
};

export const registerVersionStringBuilder = () => {
  DependencyInjectionContainer.getInstance().register(
    versionStringBuilder,
    VersionStringBuilder,
  );
};
